"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NAME = 'name';
exports.NAME = NAME;
const PHONE = 'phone';
exports.PHONE = PHONE;
const PHONE_STATUS = 'phoneStatus';
exports.PHONE_STATUS = PHONE_STATUS;
const EMAIL = 'email';
exports.EMAIL = EMAIL;
const AGE = 'age';
exports.AGE = AGE;
const GENDER = 'gender';
exports.GENDER = GENDER;
const INCOME = 'income';
exports.INCOME = INCOME;
const MARITAL = 'marital';
exports.MARITAL = MARITAL;
const ZALO_OAID = 'zalo_oa_id';
const ZALO_USERID = 'zalo_user_id';
const ZALO_USERID_BY_OAID = 'zalo_userId_by_oaId';
const ZALO_NAME = 'zalo_name';
const ZALO_PHONE = 'zalo_phone';
const ZALO_AVATAR = 'zalo_avatar';
const ZALO_BIRTHDAY = 'zalo_birthday';
const ZALO_GENDER = 'zalo_gender';
const audienceFields = [NAME, PHONE, PHONE_STATUS, EMAIL, AGE, GENDER, INCOME, MARITAL];
exports.audienceFields = audienceFields;
const zaloFields = [
    ZALO_OAID,
    ZALO_USERID,
    ZALO_USERID_BY_OAID,
    ZALO_NAME,
    ZALO_PHONE,
    ZALO_AVATAR,
    ZALO_GENDER,
    ZALO_BIRTHDAY
];
exports.zaloFields = zaloFields;
const zaloFieldsWithText = [
    {
        id: ZALO_OAID,
        text: 'Offical Account'
    },
    {
        id: ZALO_USERID,
        text: 'Zalo User Id'
    },
    {
        id: ZALO_USERID_BY_OAID,
        text: 'Zalo User By OAID'
    },
    {
        id: ZALO_NAME,
        text: 'Zalo Name'
    },
    {
        id: ZALO_PHONE,
        text: 'Zalo Phone'
    },
    {
        id: ZALO_AVATAR,
        text: 'Zalo Avatar'
    },
    {
        id: ZALO_BIRTHDAY,
        text: 'Zalo Birthday'
    },
    {
        id: ZALO_GENDER,
        text: 'Zalo Gender'
    }
];
exports.zaloFieldsWithText = zaloFieldsWithText;
const audienceFieldsWithText = [
    {
        id: NAME,
        text: 'Tên'
    },
    {
        id: PHONE,
        text: 'Số điện thoại'
    },
    {
        id: PHONE_STATUS,
        text: 'Trạng thái cuộc gọi'
    },
    {
        id: EMAIL,
        text: 'Email'
    },
    {
        id: AGE,
        text: 'Tuổi'
    },
    {
        id: GENDER,
        text: 'Giới tính'
    },
    {
        id: INCOME,
        text: 'Doanh thu'
    },
    {
        id: MARITAL,
        text: 'Hôn nhân'
    }
];
exports.audienceFieldsWithText = audienceFieldsWithText;
const getAudienceFieldName = (field) => audienceFields.indexOf(field) > -1 ? `audience.${field}` : null;
exports.getAudienceFieldName = getAudienceFieldName;
const DEVICE = 'device';
exports.DEVICE = DEVICE;
const OS = 'os';
exports.OS = OS;
const uaFields = [DEVICE, OS];
exports.uaFields = uaFields;
const uaFieldsWithText = [
    { id: DEVICE, text: 'Thiết bị' },
    { id: OS, text: 'Hệ điều hành' }
];
exports.uaFieldsWithText = uaFieldsWithText;
const getUaFieldName = (field) => (uaFields.indexOf(field) > -1 ? `ua.${field}` : null);
exports.getUaFieldName = getUaFieldName;
const customFieldCount = 10;
const customFields = Array(customFieldCount)
    .fill(0)
    .map((_, idx) => `field${idx}`);
exports.customFields = customFields;
const customFieldsWithText = customFields.map((field, idx) => ({
    id: field,
    text: `Field ${idx}`
}));
exports.customFieldsWithText = customFieldsWithText;
const getCustomFieldName = (field) => customFields.indexOf(field) > -1 ? `survey.${field}` : null;
exports.getCustomFieldName = getCustomFieldName;
const AGE_UNDER_18 = 'under_18';
const AGE_18_TO_24 = 'from_18_to_24';
const AGE_25_TO_34 = 'from_25_to_34';
const AGE_35_TO_44 = 'from_35_to_44';
const AGE_ABOVE_45 = 'higher_45';
const ageCategories = [AGE_UNDER_18, AGE_18_TO_24, AGE_25_TO_34, AGE_35_TO_44, AGE_ABOVE_45];
exports.ageCategories = ageCategories;
const ageCategoriesWithText = [
    {
        text: '< 18',
        id: AGE_UNDER_18
    },
    {
        text: '18 - 24',
        id: AGE_18_TO_24
    },
    {
        text: '25 - 34',
        id: AGE_25_TO_34
    },
    {
        text: '35 - 44',
        id: AGE_35_TO_44
    },
    {
        text: '> 45',
        id: AGE_ABOVE_45
    }
];
exports.ageCategoriesWithText = ageCategoriesWithText;
const GENDER_MALE = 'male';
const GENDER_FEMALE = 'female';
const genderCategories = [GENDER_MALE, GENDER_FEMALE];
exports.genderCategories = genderCategories;
const genderCategoriesWithText = [
    {
        text: 'Nam',
        id: GENDER_MALE
    },
    {
        text: 'Nữ',
        id: GENDER_FEMALE
    }
];
exports.genderCategoriesWithText = genderCategoriesWithText;
const MARITAL_SINGLE = 'single';
const MARITAL_IN_A_RELATIONSHIP = 'in_a_relationship';
const MARITAL_MARRIED = 'married';
const MARITAL_WITH_KIDS = 'with_kids';
const maritalCategories = [
    MARITAL_SINGLE,
    MARITAL_IN_A_RELATIONSHIP,
    MARITAL_MARRIED,
    MARITAL_WITH_KIDS
];
exports.maritalCategories = maritalCategories;
const maritalCategoriesWithText = [
    {
        text: 'Độc thân',
        id: MARITAL_SINGLE
    },
    {
        text: 'Đang hẹn hò',
        id: MARITAL_IN_A_RELATIONSHIP
    },
    {
        text: 'Đã kết hôn',
        id: MARITAL_MARRIED
    },
    {
        text: 'Đã có con',
        id: MARITAL_WITH_KIDS
    }
];
exports.maritalCategoriesWithText = maritalCategoriesWithText;
const INCOME_UNDER_1O_MIL = 'under_10_mil';
const INCOME_FROM_1O_TO_20_MIL = 'from_10_to_20_mil';
const INCOME_FROM_2O_TO_50_MIL = 'from_20_to_30_mil';
const INCOME_HIGHER_50_MIL = 'higher_50_mil';
const incomeCategories = [
    INCOME_UNDER_1O_MIL,
    INCOME_FROM_1O_TO_20_MIL,
    INCOME_FROM_2O_TO_50_MIL,
    INCOME_HIGHER_50_MIL
];
exports.incomeCategories = incomeCategories;
const incomeCategoriesWithText = [
    {
        text: '',
        id: INCOME_UNDER_1O_MIL
    },
    {
        text: '',
        id: INCOME_FROM_1O_TO_20_MIL
    },
    {
        text: '',
        id: INCOME_FROM_2O_TO_50_MIL
    },
    {
        text: '',
        id: INCOME_HIGHER_50_MIL
    }
];
exports.incomeCategoriesWithText = incomeCategoriesWithText;
const PHONE_STATUS_NO_ANSWER = 'NO ANSWER';
const PHONE_STATUS_ANSWERED = 'ANSWER';
const PHONE_STATUS_NO_BUSY = 'BUSY';
const PHONE_STATUS_NO_FAILED = 'FAILED';
const phoneStatusCategories = [
    PHONE_STATUS_NO_ANSWER,
    PHONE_STATUS_ANSWERED,
    PHONE_STATUS_NO_BUSY,
    PHONE_STATUS_NO_FAILED
];
exports.phoneStatusCategories = phoneStatusCategories;
const phoneStatusCategoriesWithText = [
    { id: PHONE_STATUS_NO_ANSWER, text: 'Không trả lời' },
    { id: PHONE_STATUS_ANSWERED, text: 'Đã trả lời' },
    { id: PHONE_STATUS_NO_BUSY, text: 'Bận' },
    { id: PHONE_STATUS_NO_FAILED, text: 'Thất bại' }
];
exports.phoneStatusCategoriesWithText = phoneStatusCategoriesWithText;
const DEVICE_MOBILE = 'Mobile';
const DEVICE_TABLET = 'Tablet';
const DEVICE_PC = 'PC';
const deviceCategories = [DEVICE_MOBILE, DEVICE_TABLET, DEVICE_PC];
exports.deviceCategories = deviceCategories;
const deviceCategoriesWithText = [
    { id: DEVICE_MOBILE, text: DEVICE_MOBILE },
    { id: DEVICE_TABLET, text: DEVICE_TABLET },
    { id: DEVICE_PC, text: DEVICE_PC }
];
exports.deviceCategoriesWithText = deviceCategoriesWithText;
const OS_ANDROID = 'Android';
const OS_IOS = 'iOS';
const OS_WINDOWS = 'Windows';
const OS_MAC_OS = 'Mac OS X';
const OS_LINUX = 'Linux';
const osCategories = [OS_ANDROID, OS_IOS, OS_WINDOWS, OS_MAC_OS, OS_LINUX];
exports.osCategories = osCategories;
const osCategoriesWithText = [
    { id: OS_ANDROID, text: OS_ANDROID },
    { id: OS_IOS, text: OS_IOS },
    { id: OS_WINDOWS, text: OS_WINDOWS },
    { id: OS_MAC_OS, text: OS_MAC_OS },
    { id: OS_LINUX, text: OS_LINUX }
];
exports.osCategoriesWithText = osCategoriesWithText;
const getCategoriesOfField = (field) => {
    switch (field) {
        case AGE:
            return ageCategories;
        case GENDER:
            return genderCategories;
        case INCOME:
            return incomeCategories;
        case MARITAL:
            return maritalCategories;
        case PHONE_STATUS:
            return phoneStatusCategories;
        case DEVICE:
            return deviceCategories;
        case OS:
            return osCategories;
        default:
            return null;
    }
};
exports.getCategoriesOfField = getCategoriesOfField;
const getCategoriesWithTextOfField = (field) => {
    switch (field) {
        case AGE:
            return ageCategoriesWithText;
        case GENDER:
            return genderCategoriesWithText;
        case INCOME:
            return incomeCategoriesWithText;
        case MARITAL:
            return maritalCategoriesWithText;
        case PHONE_STATUS:
            return phoneStatusCategoriesWithText;
        case DEVICE:
            return deviceCategoriesWithText;
        case OS:
            return osCategoriesWithText;
        default:
            return null;
    }
};
exports.getCategoriesWithTextOfField = getCategoriesWithTextOfField;
const getTextOfField = (field) => {
    const audience = audienceFieldsWithText.find(item => item.id === field);
    if (audience)
        return audience.text;
    const ua = uaFieldsWithText.find(item => item.id === field);
    if (ua)
        return ua.text;
    return null;
};
exports.getTextOfField = getTextOfField;
//# sourceMappingURL=campaignCrmFields.js.map